import React from 'react';

import { ColorInfo } from '../ColorInfo';
import { MatchInfo } from '../MatchInfo';

import styles from './ColorItem.module.scss';

const ColorItem = ({
  withMatchInfo,
  imageRef,
  image,
  color,
  text,
  matchPercent,
}: {
  withMatchInfo: any;
  imageRef: any;
  image: any;
  color: any;
  text: any;
  matchPercent: any;
}) => (
  <div className={styles.item}>
    <div
      className={styles.image}
      ref={imageRef}
      dangerouslySetInnerHTML={{ __html: image }}
    />
    <ColorInfo text={text} value={color} />
    {withMatchInfo && <MatchInfo value={matchPercent} />}
  </div>
);

export default React.memo(ColorItem) as any;
